import {
  getCustomerInfos,
  getTags,
  getTagGroup,
  getCyoPromos,
} from '../../api/api';
import { SPICY_TAG_GROUP } from '../../constants/constants';
import { spicyTagsBySpicyLevel } from '../../utils/utils';
import * as actions from './actions';

// action creators
export const getCustomerAC = (includes) => {
  return async (dispatch) => {
    try {
      const res = await getCustomerInfos(includes);
      dispatch({ type: actions.GET_CUSTOMER, customer: res.customer });
    } catch (e) {
      console.error(e);
    }
  };
};

export const getSpicyTagsAC = () => {
  return async (dispatch) => {
    try {
      const res = await getTagGroup(SPICY_TAG_GROUP);
      dispatch({
        type: actions.GET_SPICY_TAGS,
        spicyTags: spicyTagsBySpicyLevel(res.tags[0]),
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const togglePdpModal = (product) => {
  return (dispatch) => {
    dispatch({
      product,
      type: actions.TOGGLE_PDP_MODAL,
    });
  };
};

export const toggleRdpModal = (pairing) => {
  return (dispatch) => {
    dispatch({
      pairing,
      type: actions.TOGGLE_RDP_MODAL,
    });
  };
};

const getCyoPromosAC = () => {
  return async (dispatch) => {
    try {
      const res = await getCyoPromos();
      dispatch({
        type: actions.GET_CYO_PROMOS,
        cyoPromos: res,
      });
    } catch (e) {
      console.error(e);
    }
  };
};
